export interface AddressElements {
  streetNumber?: string;
  streetName?: string;
  streetSuffix?: string;
  postalCode?: string;
  city?: string;
  state?: string;
  country?: string;
  countryCode?: string;
}
